/**
 * Matches every non-alphanumeric character (keeps letters and numbers).
 */
const NonAlphanumeric = /[^A-Z0-9]/gi;

/**
 * Maps to a text containing only alphanumeric characters (letters and numbers).
 * @param value - A text containing alphanumeric characters.
 */
const mapToAlphanumeric = (value: string): string =>
  value.replace(NonAlphanumeric, "");

export default mapToAlphanumeric;
